import { useTranslation } from "react-i18next";
import type { DateStyle } from "@/shared/utils/Dates.ts";

export default function useDateFormat(
  style: DateStyle,
  timeZone: string,
): (date: Date) => string {
  const { t } = useTranslation();
  return function (date: Date) {
    return t("date", {
      date,
      formatParams: { date: { style, timeZone } },
    });
  };
}
